/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
  Grid,
  FormControlLabel,
  Paper,
} from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import {
  CustomInput, Toaster, CustomSwitch, CustomSelect, Loading,
  CustomModal,
} from '../../../../components';
import { Rules } from '../../../../helpers/RHFRules';
import { ActionPopUp } from '../../../../Layouts';
import {
  updateCommercialCategory,
  postComercialCategoryService,
  createRubro,
} from '../../../../services';
import { errorAlert } from '../../constants';
import { RISK_CLASIFICATION } from './constants';
import DropdownWithFilter from '../../../../components/DropDown/DropDown';
import { convertToSpanish } from '../BulkLoadPreview/utils';
import normalizeString from './utils';
import useStyle from './useStyle';

const ActionForm = ({
  open,
  data,
  title,
  onClose,
  getCommercialCategories,
  defaultValues,
  sectorsList,
  fetchAllRubros,
  comercialCategoryList,
  updateMode = false,
}) => {
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openDescriptionDuplicateConfirm, setOpenDescriptionDuplicateConfirm] = useState(false);
  const [conflictingDescriptionCategoryData, setConflictingDescriptionCategoryData] = useState(null);
  const [mccChangeConfirmOpen, setMccChangeConfirmOpen] = useState(false);
  const classes = useStyle();
  const providerRef = useRef();

  const {
    handleSubmit,
    control,
    errors,
    reset,
    getValues,
    setValue,
  } = useForm({ defaultValues });

  const createCommercialCategory = async (payload) => {
    setLoading(true);
    const { status } = await postComercialCategoryService(payload);
    if (status === 201) {
      setLoading(false);
      return true;
    }
    setLoading(false);
    setAlert(errorAlert);
    return false;
  };

  const updateCommercialCategoryApi = async (payload) => {
    setLoading(true);
    const { status } = await updateCommercialCategory(payload);
    if (status === 200) {
      setLoading(false);
      return true;
    }
    setLoading(false);
    setAlert(errorAlert);
    return false;
  };

  const updateCommercialCategoryValues = async (targetRecordData) => {
    const recordIdToUpdate = targetRecordData?.detail_id;

    if (!recordIdToUpdate) {
      setAlert({ status: true, type: 'error', message: 'No se pudo identificar el registro a actualizar.' });
      setLoading(false);
      return;
    }

    setMccChangeConfirmOpen(false);
    setOpenDescriptionDuplicateConfirm(false);
    setLoading(true);

    const {
      classification, description, mcc, rubro, visibleEnApp,
    } = getValues();

    const selectedRubroKey = String(rubro).toUpperCase();
    const selectedRubro = sectorsList[selectedRubroKey];

    if (!selectedRubro && (updateMode || !updateMode)) {
      setAlert({ status: true, type: 'error', message: 'Por favor, seleccione un Rubro válido.' });
      setLoading(false);
      return;
    }

    const payload = {
      detail_id: recordIdToUpdate,
      detail_name_es: description,
      mcc: Number(mcc),
      itbis: active,
      rubro: selectedRubro.description,
      rubro_id: selectedRubro.id,
      classification,
      justBackOffice: !visibleEnApp,
      enabled: targetRecordData?.enabled ?? true,
    };

    const success = await updateCommercialCategoryApi(payload);

    if (success) {
      await getCommercialCategories();
      providerRef.current.enqueueSnackbar('Se ha actualizado la categoría comercial exitosamente', {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
      onClose();
    }
    setLoading(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);
    const normalizedFormDescription = normalizeString(formData.description);

    const conflictingCategory = comercialCategoryList.find(
      (cat) => normalizeString(cat.detail_name_es) === normalizedFormDescription,
    );

    if (conflictingCategory) {
      setConflictingDescriptionCategoryData(conflictingCategory);
      setOpenDescriptionDuplicateConfirm(true);
      setLoading(false);
      return;
    }

    const selectedRubroKey = String(formData.rubro).toUpperCase();
    const selectedRubro = sectorsList[selectedRubroKey];

    if (!selectedRubro) {
      setAlert({ status: true, type: 'error', message: 'Por favor, seleccione un Rubro válido.' });
      setLoading(false);
      return;
    }

    const body = {
      detail_name_es: formData.description,
      mcc: Number(formData.mcc),
      itbis: active,
      justBackOffice: !formData.visibleEnApp,
      rubro: selectedRubro.description,
      rubro_id: selectedRubro.id,
      classification: formData.classification,
      enabled: true,
    };

    const isSuccess = await createCommercialCategory(body);
    if (isSuccess) {
      await getCommercialCategories();
      providerRef.current.enqueueSnackbar('Se ha creado la categoría comercial exitosamente', {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
      onClose();
    }
    if (!isSuccess) setLoading(false);
  };

  const saveCategory = () => handleSubmit(handleSave);

  const checkDescriptionAndProceedWithUpdate = async () => {
    setLoading(true);
    const currentValues = getValues();
    const originalId = defaultValues?.detail_id;
    if (!originalId) {
      setAlert({ status: true, type: 'error', message: 'No se encontró el ID original para actualizar.' });
      setLoading(false);
      return;
    }

    const normalizedFormDescription = normalizeString(currentValues.description);

    const conflictingCategory = comercialCategoryList.find((cat) => cat.detail_id !== originalId && normalizeString(cat.detail_name_es) === normalizedFormDescription);

    if (conflictingCategory) {
      setConflictingDescriptionCategoryData(conflictingCategory);
      setOpenDescriptionDuplicateConfirm(true);
      setLoading(false);
      return;
    }

    await handleSubmit(async () => {
      await updateCommercialCategoryValues({ detail_id: originalId, enabled: defaultValues?.enabled });
    })();
  };

  const updateCategory = async () => {
    const currentValues = getValues();
    const originalMcc = defaultValues?.mcc;
    const originalId = defaultValues?.detail_id;

    if (!originalId && updateMode) {
      setAlert({ status: true, type: 'error', message: 'No se pudo identificar el registro a actualizar (ID faltante).' });
      return;
    }

    if (originalMcc !== undefined && String(currentValues.mcc) !== String(originalMcc)) {
      setMccChangeConfirmOpen(true);
    } else {
      await checkDescriptionAndProceedWithUpdate();
    }
  };

  const handleOnclose = () => {
    reset(defaultValues);
    setMccChangeConfirmOpen(false);
    setOpenDescriptionDuplicateConfirm(false);
    setConflictingDescriptionCategoryData(null);
    setAlert({ status: false, type: '', message: '' });
    setActive(!!defaultValues?.itbis);
    setValue('visibleEnApp', !!defaultValues?.visibleEnApp);

    onClose();
  };

  const getRubroOptions = (rubrosList) => rubrosList.map((rubro) => ({ value: rubro, label: rubro }));

  const getUpdateExistingDescriptionModalMessage = () => {
    if (!conflictingDescriptionCategoryData) return 'Error: No se encontró la categoría conflictiva.';

    const currentFormValues = getValues();
    const formDescription = currentFormValues.description;
    const formRubroKey = String(currentFormValues.rubro).toUpperCase();
    const formRubroDescription = sectorsList[formRubroKey]?.description || formRubroKey;
    const formRiskLabel = convertToSpanish(currentFormValues.classification);
    const formItbis = active ? 'Sí' : 'No';
    const formMcc = currentFormValues.mcc;

    const existingDescription = conflictingDescriptionCategoryData.detail_name_es ?? 'N/A';
    const existingRubro = conflictingDescriptionCategoryData.rubro ?? 'N/A';
    const existingRiskLabel = convertToSpanish(conflictingDescriptionCategoryData.classification);
    const existingItbis = conflictingDescriptionCategoryData.itbis ? 'Sí' : 'No';
    const existingMcc = conflictingDescriptionCategoryData.mcc ?? 'N/A';

    return (
      <>
        <p>
          La descripción
          <strong>
            {` "${formDescription}" `}
          </strong>
          ya está asignada a otra categoría (MCC
          {` ${existingMcc}`}
          ).
        </p>
        <p>
          <strong>
            ¿Confirmas que deseas actualizar esa categoría existente (MCC
            {` ${existingMcc}`}
            )?
          </strong>
        </p>
        <div className={classes.ModalMessageBody}>
          <strong>
            Datos ACTUALES
          </strong>
          <ul className={classes.ModalMessageList}>
            <li>
              Descripción:
              {` ${existingDescription}`}
            </li>
            <li>
              MCC:
              <strong>{` ${existingMcc}`}</strong>
            </li>
            <li>
              Rubro:
              {` ${existingRubro}`}
            </li>
            <li>
              Riesgo:
              {` ${existingRiskLabel}`}
            </li>
            <li>
              Aplica Itbis:
              {` ${existingItbis}`}
            </li>
          </ul>
        </div>
        <div className={classes.ModalMessageBody}>
          <strong>Se SOBRESCRIBIRÁ con estos datos:</strong>
          <ul className={classes.ModalMessageList}>
            <li>
              Descripción:
              <strong>{` ${formDescription}`}</strong>
            </li>
            <li>
              MCC:
              <strong>{` ${formMcc}`}</strong>
            </li>
            <li>
              Rubro:
              <strong>{` ${formRubroDescription}`}</strong>
            </li>
            <li>
              Riesgo:
              <strong>{` ${formRiskLabel}`}</strong>
            </li>
            <li>
              Aplica Itbis:
              <strong>{` ${formItbis}`}</strong>
            </li>
          </ul>
        </div>
        <p className={classes.ModalMessageFooter}>
          Al aceptar, se modificarán los datos de la categoría existente (MCC
          {` ${existingMcc}`}
          ).
        </p>
      </>
    );
  };

  const handleAddOption = async (newOption) => {
    setLoading(true);
    try {
      const payload = {
        id: '',
        description: newOption.toUpperCase(),
        enabled: true,
      };
      const { status } = await createRubro(payload);
      if (status === 201) {
        await fetchAllRubros();
        setValue('rubro', newOption.toUpperCase());
      } else {
        setAlert(errorAlert);
      }
    } catch {
      setAlert(errorAlert);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initialItbis = !!data?.active;
    const initialVisible = defaultValues?.visibleEnApp ?? true;
    const initialRubroValue = String(defaultValues?.rubro || '').toUpperCase();
    reset({
      ...defaultValues,
      rubro: initialRubroValue,
      visibleEnApp: initialVisible,
      classification: defaultValues?.classification || '',
      mcc: defaultValues?.mcc || '',
      description: defaultValues?.description || '',
    });
    setActive(initialItbis);
    setMccChangeConfirmOpen(false);
    setOpenDescriptionDuplicateConfirm(false);
    setConflictingDescriptionCategoryData(null);
  }, [defaultValues, reset, data, setValue]);

  return (
    <SnackbarProvider ref={providerRef}>
      {loading ? <Loading /> : null}
      <ActionPopUp
        open={open}
        data={data}
        title={title}
        onClose={handleOnclose}
        onSave={updateMode ? updateCategory : saveCategory()}
        enabledControls={!loading}
      >
        <>
          {mccChangeConfirmOpen && (
            <CustomModal
              isOpen={mccChangeConfirmOpen}
              title="Confirmar Cambio de MCC"
              firstButtonLabel="Continuar"
              text="Estás a punto de modificar el MCC de la categoría. ¿Estás seguro de que deseas continuar?"
              firstButtonAction={async () => {
                setMccChangeConfirmOpen(false);
                await checkDescriptionAndProceedWithUpdate();
              }}
              setIsOpen={setMccChangeConfirmOpen}
              secondButtonLabel="Cancelar"
              secondButtonAction={() => {
                setMccChangeConfirmOpen(false);
                setLoading(false);
              }}
            />
          )}

          {openDescriptionDuplicateConfirm && conflictingDescriptionCategoryData && (
            <CustomModal
              isOpen={openDescriptionDuplicateConfirm}
              title="¡Descripción Existente!"
              firstButtonLabel="Actualizar Existente"
              firstButtonAction={() => { updateCommercialCategoryValues(conflictingDescriptionCategoryData); }}
              setIsOpen={setOpenDescriptionDuplicateConfirm}
              secondButtonLabel="Cancelar"
              secondButtonAction={() => {
                setOpenDescriptionDuplicateConfirm(false);
                setLoading(false);
              }}
            >
              {getUpdateExistingDescriptionModalMessage()}
            </CustomModal>
          )}

          <div className={classes.Separator}>&nbsp;</div>
          <form noValidate autoComplete="off">
            <Grid container justifyContent="space-evenly" alignItems="stretch" spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomInput label="MCC *" name="mcc" control={control} rule={Rules.required} error={errors} inputProps={{ maxLength: 30 }} type="number" />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomInput label="Descripción *" name="description" control={control} rule={Rules.required} error={errors} inputProps={{ maxLength: 50 }} />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Controller
                  render={({ value, onChange }) => (
                    <DropdownWithFilter
                      label="Elegir Categoría/Rubro *"
                      options={getRubroOptions(Object.keys(sectorsList))}
                      value={value}
                      onChange={(newValue) => onChange(newValue)}
                      onAddOption={handleAddOption}
                    />
                  )}
                  name="rubro"
                  control={control}
                  rules={Rules.required}
                  error={Boolean(errors.rubro)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomSelect label="Clasificación de Riesgo *" name="classification" control={control} error={errors} options={RISK_CLASIFICATION} rule={Rules.required} />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Paper
                  variant="outlined"
                  className={classes.Paper}
                >
                  <FormControlLabel className={classes.ControlLabel} control={<CustomSwitch checked={active} onChange={(e) => setActive(e.target.checked)} name="itbis" color="black" />} label="Aplica Itbis" labelPlacement="start" />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Paper
                  variant="outlined"
                  className={classes.Paper}
                >
                  <Controller
                    render={({ value, onChange }) => (
                      <FormControlLabel
                        className={classes.ControlLabel}
                        control={(
                          <CustomSwitch
                            checked={value}
                            onChange={(e) => onChange(e.target.checked)}
                            name="Visible en App"
                            color="black"
                          />
                        )}
                        label="Visible en App?"
                        labelPlacement="start"
                      />
                    )}
                    name="visibleEnApp"
                    control={control}
                    error={Boolean(errors.visibleEnApp)}
                  />
                </Paper>
              </Grid>
            </Grid>
            <div className={classes.Separator}>&nbsp;</div>
          </form>
        </>

        <Toaster
          show={alert.status}
          type={alert.type}
          text={alert.message}
          onClose={() => setAlert({ ...alert, status: false })}
        />
      </ActionPopUp>
    </SnackbarProvider>
  );
};

ActionForm.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  getCommercialCategories: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  sectorsList: PropTypes.object.isRequired,
  fetchAllRubros: PropTypes.func.isRequired,
  comercialCategoryList: PropTypes.array.isRequired,
  updateMode: PropTypes.bool,
};

ActionForm.defaultProps = {
  data: null,
  defaultValues: {},
  updateMode: false,
};

export default ActionForm;
